import React from "react";
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import moment from "moment";

const SalesOrderInvoice = ({ tableData = [] }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];

  const viewInvoice = (invoiceId) => {
    navigate(`/${currModuleId}/${currModuleName}/invoices/details/${invoiceId}`);
  };

  if (!tableData.length) {
    return (
      <div className="mt-2 py-6 text-center text-sm text-gray-400 border border-gray-200 rounded-lg bg-white">
        No invoices found.
      </div>
    );
  }

  return (
    <div className="mt-2 border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm">
      <TableContainer>
        <Table size="small" aria-label="invoices table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F8F8F8" }}>
              {["Reference No", "Invoice No", "Date", "Amount"].map((h) => (
                <TableCell
                  key={h}
                  sx={{
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    color: "#6B7280",
                    py: 1,
                    borderBottom: "1px solid #E5E7EB",
                  }}
                >
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((invoice, i) => (
              <TableRow
                key={i}
                sx={{
                  "&:last-child td": { border: 0 },
                  "&:hover": { backgroundColor: "#FAFAFA" },
                }}
              >
                <TableCell sx={{ fontSize: "0.8rem", py: 0.75, color: "#374151" }}>
                  {invoice.invoice_ref_no}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "0.8rem", py: 0.75, color: "#2563EB", cursor: "pointer" }}
                  onClick={() => viewInvoice(invoice.invoice_ref_no)}
                >
                  {invoice.invoice_no}
                </TableCell>
                <TableCell sx={{ fontSize: "0.8rem", py: 0.75, color: "#374151" }}>
                  {moment(invoice.invoice_date).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell sx={{ fontSize: "0.8rem", py: 0.75, color: "#111827", fontWeight: 500 }}>
                  <CurrencyFormat
                    value={invoice.invoice_amount?.toFixed(2)}
                    displayType="text"
                    thousandSeparator={true}
                    prefix="₦"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default SalesOrderInvoice;